import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { ModalStep, NoIndicatorSteps } from '../../utils/steps.js';
import { SignUpStep } from '../SignUpStep/SignUpStep.js';
import { CpslAlert, CpslProgressIndicator } from '@usecapsule/react-components';
import { VerificationCodeStep } from '../VerificationCodeStep/VerificationCodeStep.js';
import { useModalStore, useThemeStore } from '../../stores/index.js';
import { BiometricLoginStep } from '../BiometricLoginStep/BiometricLoginStep.js';
import { Setup2FAStep } from '../Setup2FAStep/Setup2FAStep.js';
import { LoginDoneStep } from '../LoginDoneStep/LoginDoneStep.js';
import { AwaitingBiometricsStep } from '../AwaitingBiometricsStep/AwaitingBiometricsStep.js';
import { AwaitingWalletCreationStep } from '../AwaitingWalletCreationStep/AwaitingWalletCreationStep.js';
import { WalletCreationDoneStep } from '../WalletCreationDoneStep/WalletCreationDoneStep.js';
import { RecoverySecretStep } from '../RecoverySecretStep/RecoverySecretStep.js';
import { TwoFactorDoneStep } from '../TwoFactorDoneStep/TwoFactorDoneStep.js';
import { BiometricCreationStep } from '../BiometricCreationStep/BiometricCreationStep.js';
import { AwaitingOAuthStep } from '../AwaitingOAuthStep/AwaitingOAuthStep.js';
import { AddFundsAwaiting, AddFundsDone, AddFunds } from '../AddFunds/index.js';
import { VerificationCodeStepForPhone } from '../VerificationCodeStep/VerificationCodeStepForPhone.js';
import FarcasterOAuthStep from '../OAuth/FarcasterOAuthStep.js';
export const Body = ({ oAuthMethods, recoveryShare, twoFactorAuthEnabled, hasFinishedAnimation, disableEmailLogin, disablePhoneLogin, networks = ['ETHEREUM'], onClose, }) => {
    const currentStep = useModalStore(state => state.step);
    const stepNumber = useModalStore(state => state.stepNumber());
    const totalSteps = useModalStore(state => state.totalSteps());
    const isLogin = useModalStore(state => state.isLogin());
    const onRampConfig = useModalStore(state => state.onRampConfig);
    const appName = useThemeStore(state => state.appName);
    const showProgressIndicator = !isLogin && !NoIndicatorSteps.includes(currentStep);
    const Content = () => {
        switch (currentStep) {
            case ModalStep.SIGN_UP:
            case ModalStep.SIGN_UP_ALL_OAUTH: {
                return (_jsx(SignUpStep, { oAuthMethods: oAuthMethods, disableEmailLogin: disableEmailLogin, disablePhoneLogin: disablePhoneLogin }));
            }
            case ModalStep.VERIFICATION_CODE: {
                return _jsx(VerificationCodeStep, {});
            }
            case ModalStep.VERIFICATION_CODE_FOR_PHONE: {
                return _jsx(VerificationCodeStepForPhone, {});
            }
            case ModalStep.BIOMETRIC_LOGIN: {
                return _jsx(BiometricLoginStep, {});
            }
            case ModalStep.SETUP_2FA:
            case ModalStep.VERIFY_2FA: {
                return _jsx(Setup2FAStep, { onClose: onClose });
            }
            case ModalStep.LOGIN_DONE: {
                return _jsx(LoginDoneStep, { onClose: onClose });
            }
            case ModalStep.AWAITING_BIOMETRIC_LOGIN:
            case ModalStep.AWAITING_BIOMETRIC_CREATION: {
                return _jsx(AwaitingBiometricsStep, {});
            }
            case ModalStep.AWAITING_WALLET_CREATION: {
                return _jsx(AwaitingWalletCreationStep, {});
            }
            case ModalStep.WALLET_CREATION_DONE: {
                return _jsx(WalletCreationDoneStep, { twoFactorAuthEnabled: twoFactorAuthEnabled, onClose: onClose });
            }
            case ModalStep.SECRET: {
                return _jsx(RecoverySecretStep, { recoveryShare: recoveryShare });
            }
            case ModalStep.TWO_FACTOR_DONE: {
                return _jsx(TwoFactorDoneStep, { onClose: onClose });
            }
            case ModalStep.BIOMETRIC_CREATION: {
                return _jsx(BiometricCreationStep, { hasFinishedAnimation: hasFinishedAnimation });
            }
            case ModalStep.AWAITING_OAUTH: {
                return _jsx(AwaitingOAuthStep, {});
            }
            case ModalStep.FARCASTER_OAUTH: {
                return _jsx(FarcasterOAuthStep, {});
            }
            case ModalStep.ADD_FUNDS: {
                return _jsx(AddFunds, { hasFinishedAnimation: hasFinishedAnimation, networks: networks });
            }
            case ModalStep.ADD_FUNDS_AWAITING: {
                return _jsx(AddFundsAwaiting, {});
            }
            case ModalStep.ADD_FUNDS_SUCCESS: {
                return _jsx(AddFundsDone, { isSuccess: true, onClose: onClose });
            }
            case ModalStep.ADD_FUNDS_FAILURE: {
                return _jsx(AddFundsDone, { onClose: onClose });
            }
        }
    };
    return (_jsxs(BodyContainer, { slot: "body", children: [showProgressIndicator && _jsx(StyledCpslProgressIndicator, { step: stepNumber - 1, totalSteps: totalSteps }), (onRampConfig === null || onRampConfig === void 0 ? void 0 : onRampConfig.testMode) &&
                [
                    ModalStep.ADD_FUNDS,
                    ModalStep.ADD_FUNDS_AWAITING,
                    ModalStep.ADD_FUNDS_FAILURE,
                    ModalStep.ADD_FUNDS_SUCCESS,
                ].includes(currentStep) && (_jsx(CpslAlert, { children: _jsxs("div", { style: { fontSize: '12px' }, children: ["This Capsule Modal is configured to run on-ramp services in ", _jsx("b", { children: "test mode" }), " only, for development purposes. If you are a user of ", appName, ", please contact support."] }) })), Content()] }));
};
const BodyContainer = styled.div `
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
const StyledCpslProgressIndicator = styled(CpslProgressIndicator) `
  width: 50%;
  align-self: center;
`;
